import { render, staticRenderFns } from "./BAutocompleteFormsHandbook.vue?vue&type=template&id=2ca7c143&"
import script from "./BAutocompleteFormsHandbook.vue?vue&type=script&lang=js&"
export * from "./BAutocompleteFormsHandbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports